export default {
    selectWorkCheckList: "/gateway/huilian/huilianWorkcs/selectWorkCheckList", //查询审批人列表
    programme: "/gateway/manageBedrock/programme/detail", //查看方案呈批
    contract: "/gateway/manageBedrock/contract/detail", //查看合同
    pay: "/gateway/manageBedrock/pay/detail", //查看付款
    travelPay: "/gateway/manageBedrock/travelPay/detail", //查看付款-差旅
    entertainPay: "/gateway/manageBedrock/entertainPay/detail", //查看付款-招待
    seal: "/gateway/manageBedrock/seal/detail", //查看印章管理
    entertainApply: "/gateway/manageBedrock/entertainApply/detail", //查看招待费用
    travelApply: "/gateway/manageBedrock/travelApply/detail", //查看出差申请
    special: "/gateway/manageBedrock/special/detail", // 法律专项
    mattercs: "/gateway/manageBedrock/mattercs/detail", //通用数据订正申请,控车白名单申请,收车日期变更,已收账单退回审批
    carScrap: "/gateway/huilian/scrapcs/queryCarScrap", // 查看车辆报废详情
    selectInsurancePremiumByRentalCode: "/gateway/carMinister/insurancecs/selectInsurancePremiumByRentalCode", // 根据租赁编码查询保险费用
    selectInsuranceDetailByRentalCode: "/gateway/carMinister/insurancecs/selectInsuranceDetailByRentalCode", // 根据租赁编码查询投保明细
};



// WEBPACK FOOTER //
// ./src/processReview/api.js